import {
  DocumentSigningTemplateBlock,
  SignedBlockContent,
} from '../../../../lib/db/db.types'
import { blockTypeToLabel } from '../SignDocumentFlow.utils'
import { DateSignedBoxes } from './DateSignedBoxes'

type BlockContentDisplayProps = {
  block: DocumentSigningTemplateBlock
  signedBlockContent?: SignedBlockContent | null
}

const BlockContentDisplayInner = ({
  block,
  signedBlockContent,
}: BlockContentDisplayProps) => {
  if (!signedBlockContent) {
    return (
      <div className="text-sm text-gray-500">
        {blockTypeToLabel[block.type]}
      </div>
    )
  }

  switch (signedBlockContent.type) {
    case 'text':
      return (
        <div className="text-sm text-gray-500">{signedBlockContent.text}</div>
      )
    case 'image':
      return <img src={signedBlockContent.imageSrc} alt="Signature" />
    case 'date-boxes':
      return (
        <DateSignedBoxes
          date={signedBlockContent.date}
          width={block.size.width}
          height={block.size.height}
        />
      )
  }
}

export const BlockContentDisplay = (props: BlockContentDisplayProps) => {
  return (
    <div>
      <BlockContentDisplayInner {...props} />
    </div>
  )
}
